import React, { Component } from "react";
import { Container } from "reactstrap";
import { RouterProps, Styled } from "../../../../toolkit/decorators/Artifact";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfig } from "./ReporteAsesor.form";
import { MemoTable } from "./ReporteAsesor.table";
import { ReporteAsesorResumen } from "./ReporteAsesorResumen.cards";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import FormBuilderModal from "../../common/formBuilderModal/formBuilderModal";
import { cambiarVendedorFormConfig } from "./ReporteAsesorVendedor.form";
import { gestionFormConfig } from "./ReporteAsesorGestion.form";
import { ReporteAsesorDispatcher } from "../../../containers/comisionesMembresia/reporteAsesor/ReporteAsesor.dispatcher";
import { ReporteAsesorStore } from "../../../containers/comisionesMembresia/reporteAsesor/ReporteAsesor.store";
import MembresiaSnapshot from "../../../../types/MembresiaSnapshot";
import {
  errorNotification,
  infoNotification,
  successNotification
} from "../../../../utils/notifications";
import { Preview } from "../../../../types/IAction";
import { GetSnapshot } from "../../../reducers/comisionMembresia";
import {
  downloadSnapshotByAsesor,
  downloadSnapshotByFolioFactura,
  downloadSnapshotByPeriodo
} from "../../../actions/comisionMembresia";
import ConfirmModal from "../../common/confirmModal/confirmModal";
import s from "./styles.scss";

interface Props
  extends ReporteAsesorDispatcher,
    ReporteAsesorStore,
    RouterProps {}

interface State {
  downloading: boolean;
  filters: Inputs & {
    periodo: string;
    page: number;
    size: number;
  };

  row: MembresiaSnapshot;
  actualizarPopupOpen: boolean;
  cambiarVendedorPopupOpen: boolean;
  descartarPopupOpen: boolean;
}

@Styled(s)
export default class ReporteAsesorComponent extends Component<Props, State> {
  state = {
    downloading: false,
    filters: {
      periodo: null,
      page: 0,
      size: 9999
    } as any,
    currentResumen: null,

    row: null as MembresiaSnapshot,
    actualizarPopupOpen: false,
    cambiarVendedorPopupOpen: false,
    descartarPopupOpen: false
  };

  componentDidMount(): void {
    this.props.clearSnapshot();
    this.props.clearResumen();
  }

  clear = () => {
    this.setState({
      filters: {
        page: 0,
        size: 9999
      } as any
    });
  };

  fetchData = async ({ page, pageSize }) => {
    const { filters } = this.state;
    const params = {
      ...filters,
      page,
      size: pageSize
    };

    let preview: Preview<GetSnapshot>;

    preview = await this.props.getSnapshotByAsesor(
      params.periodo,
      params.idVendedor,
      params.page,
      params.size,
      params.tipoOperacion
    );

    if (!preview.fulfilled) {
      errorNotification(preview.gettingSnapshotError);
    }
  };

  submit = (data: { [key in Inputs]: any }) => {
    const periodo = `${data.anio || new Date().getFullYear()}-${data.mes}-01`;
    this.setState(
      {
        filters: {
          ...data,
          periodo,
          page: 0,
          size: 9999
        } as any
      },
      () => {
        this.fetchData({ page: 0, pageSize: 9999 });
        this.props.getResumenByAsesor(periodo, data.idVendedor || undefined);
      }
    );
  };

  handleExport = async () => {
    const { filters } = this.state;
    this.setState({ downloading: true });
    downloadSnapshotByAsesor(filters.periodo, filters.idVendedor, () =>
      this.setState({ downloading: false })
    );
  };

  handleActualizarSnapshot = (row: MembresiaSnapshot) => {
    this.setState({
      actualizarPopupOpen: true,
      row: row
    });
  };

  handleActualizarSubmit = async data => {
    const { row } = this.state;
    const preview = await this.props.putSnapshotEvaluacion(
      row.idCotizacionItem,
      {
        modo: data.modo,
        observaciones: data.observaciones,
        idMembresiaActualizacion: data.idMembresiaActualizacion
          ? parseInt(data.idMembresiaActualizacion as any)
          : null
      }
    );

    if (preview.fulfilled) {
      successNotification("La membresía se configuró correctamente");

      this.setState({
        actualizarPopupOpen: false,
        row: null
      });
      this.fetchData({
        page: this.state.filters.page,
        pageSize: this.state.filters.size
      });
    } else {
      errorNotification(preview.puttingSnapshotEvaluacionError);
    }
  };

  handleCambiarVendedor = (row: MembresiaSnapshot) => {
    this.setState({
      row,
      cambiarVendedorPopupOpen: true
    });
  };

  handleCambiarVendedorSubmit = async data => {
    const { row } = this.state;
    const preview = await this.props.putCambiarVendedor(row.idCotizacionItem, {
      idVendedor: parseInt(data.idVendedor as any),
      razonCambioVendedor: data.razonCambioVendedor
    });

    if (preview.fulfilled) {
      successNotification("Vendedor actualizado correctamente");

      this.setState({
        cambiarVendedorPopupOpen: false,
        row: null
      });
      this.fetchData({
        page: this.state.filters.page,
        pageSize: this.state.filters.size
      });
    } else {
      errorNotification(preview.puttingCambiarVendedorError);
    }
  };

  handleDescartarCambios = (row: MembresiaSnapshot) => {
    this.setState({
      row,
      descartarPopupOpen: true
    });
  };

  handleDescartarConfirm = async () => {
    const { row } = this.state;
    const result = await this.props.deleteSnapshotEvaluacion(
      row.idCotizacionItem
    );

    if (result.fulfilled) {
      successNotification("Los cambios se descartaron correctamente");

      this.setState({
        descartarPopupOpen: false,
        row: null
      });
      this.fetchData({
        page: this.state.filters.page,
        pageSize: this.state.filters.size
      });
    } else {
      errorNotification(result.deletingSnapshotEvaluacionError);
    }
  };

  render() {
    const {
      row,
      actualizarPopupOpen,
      cambiarVendedorPopupOpen,
      descartarPopupOpen
    } = this.state;

    return (
      <Container>
        <ReporteAsesorResumen
          resumen={this.props.resumenAsesor}
          loading={
            this.props.gettingResumenAsesor || this.props.gettingSnapshot
          }
        />

        <div style={{ margin: "0 15px" }}>
          <FormBuilder<Inputs, Buttons>
            config={formConfig}
            submit={this.submit}
            processing={
              this.props.gettingSnapshot ||
              this.props.gettingResumenSnapshot ||
              this.props.postingSnapshotByPeriodo ||
              this.state.downloading
            }
          />
        </div>

        {this.props.snapshot && (
          <MemoTable
            page={this.props.snapshot}
            loading={
              this.props.gettingSnapshot ||
              this.props.gettingResumenSnapshot ||
              this.props.postingSnapshotByPeriodo ||
              this.state.downloading
            }
            onFetchData={this.fetchData}
            onExport={this.handleExport}
            onActualizarSnapshot={this.handleActualizarSnapshot}
            onCambiarVendedor={this.handleCambiarVendedor}
            onDescartarCambios={this.handleDescartarCambios}
          />
        )}

        <FormBuilderModal
          isOpen={actualizarPopupOpen}
          title={`Actualizar Cotización ${!!row && row.idCotizacionItem}`}
          message={""}
          ok={this.handleActualizarSubmit}
          cancel={() => this.setState({ actualizarPopupOpen: false })}
          formConfig={gestionFormConfig}
          values={{
            modo: (row && row.modo) || "",
            observaciones: (row && row.observaciones) || "",
            idMembresiaActualizacion:
              (row && row.idMembresiaActualizacion) || ""
          }}
        />

        <FormBuilderModal
          isOpen={cambiarVendedorPopupOpen}
          title={`Vendedor de Cotización ${!!row && row.idCotizacionItem}`}
          message={""}
          ok={this.handleCambiarVendedorSubmit}
          cancel={() => this.setState({ cambiarVendedorPopupOpen: false })}
          formConfig={cambiarVendedorFormConfig}
          values={{
            idVendedor: (row && row.idVendedor) || "",
            razonCambioVendedor: ""
          }}
        />

        <ConfirmModal
          isOpen={descartarPopupOpen}
          title={`Reestablecer Cotización ${!!row && row.idCotizacionItem}`}
          message={"Los cambios detectados y sus comentarios serán ignorados."}
          ok={this.handleDescartarConfirm}
          cancel={() => this.setState({ descartarPopupOpen: false })}
          size={"md"}
          waiting={this.props.deletingSnapshotEvaluacion}
        />
      </Container>
    );
  }
}
